import axios from "axios";
import { parseSqlDateTime } from "../components/common/utils/utils";
import { setLoading, setTemplates } from "../reducers/templates";
import { AppThunk } from "../redux/store";
import { Template } from "../typeDefs/templates";
import { setErrorMessage } from "./common";

export const getTemplates = (): AppThunk<void> => (dispatch) => {
    dispatch(setLoading(true));
    axios
        .get("api/templates/all")
        .then((res) => {
            dispatch(
                setTemplates(
                    res.data
                        .map(
                            (template: any): Template => ({
                                Id: template.Id,
                                ImageUrl: template.ImageUrl,
                                Name: template.Name,
                                DownloadUrl: template.DownloadUrl,
                                Description: template.Description,
                                Type: template.Type,
                                Tags: template.Tags.split(",").map(
                                    (tag: string): string => tag.trim()
                                ),
                                DateAdded: parseSqlDateTime(template.DateAdded),
                                SponsoredSortOrder: template.SponsoredSortOrder,
                                Downloads: template.Downloads,
                                LongDescription: template.LongDescription,
                                Integrations: template.Integrations,
                                TablesUsed: template.TablesUsed.split(","),
                                Layouts: template.Layouts.split(","),
                                IsCopilotEnabled: template.IsCopilotEnabled,
                            })
                        )
                        .sort(
                            (a: Template, b: Template) =>
                                a.SponsoredSortOrder - b.SponsoredSortOrder
                        )
                )
            );
            dispatch(setLoading(false));
        })
        .catch((err) => {
            dispatch(setErrorMessage("Could not get templates"));
            dispatch(setLoading(false));
            console.error(err);
        });
};

export const getTemplateById =
    (downloadUrl: string): AppThunk<Promise<Template | undefined>> =>
    async (dispatch) => {
        dispatch(setLoading(true));
        try {
            const res = await axios.get(
                `api/templates/by-id?downloadUrl=${downloadUrl}`
            );

            const template: Template = {
                Id: res.data.Id,
                ImageUrl: res.data.ImageUrl,
                Name: res.data.Name,
                DownloadUrl: res.data.DownloadUrl,
                Description: res.data.Description,
                Type: res.data.Type,
                Tags: res.data.Tags.split(",").map((tag: string): string =>
                    tag.trim()
                ),
                DateAdded: parseSqlDateTime(res.data.DateAdded),
                SponsoredSortOrder: res.data.SponsoredSortOrder,
                Downloads: res.data.Downloads,
                LongDescription: res.data.LongDescription,
                Integrations: res.data.Integrations,
                TablesUsed: res.data.TablesUsed.split(","),
                Layouts: res.data.Layouts.split(","),
                IsCopilotEnabled: res.data.IsCopilotEnabled,
            };

            dispatch(setLoading(false));
            return template;
        } catch (err) {
            dispatch(setErrorMessage("Could not get template"));
            dispatch(setLoading(false));
            console.error(err);
        }
    };

export const downloadTemplate = (downloadUrl: string) => {
    axios
        .put(`api/templates/increment?downloadUrl=${downloadUrl}`)
        .then(() => {
            window.open(
                `${window.location.origin}/api/templates/file/${downloadUrl}`
            );
        })
        .catch((err) => {
            console.error(err);
        });
};
